<template>
  <div class="pay-ali-config">
    <p class="alipay-info-title">{{$t('zhi_fu_bao_pu_tong_shang_hu')}}</p>

    <div class="pay-ali-config-container">


      <el-form ref="form" :model="info" :rules="rules" label-width="80px" class="item-form" size="small">
        <el-form-item :label="$t('zhi_fu_ming_cheng')" prop="name">
          <el-input v-model="info.name" :placeholder="$t('qing_shu_ru_zhi_fu_ming_cheng')"
                    style="width: 240px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('payAuth')">
          <div class="qr-code">
            <qrcode :value="accessTokenUrl" :options="{ width: 200 }"></qrcode>
            <div class="mark" v-show="isMask">
              <p>{{$t('fill_payment_name')}}</p>
              <p>【{{$t('createAuthorizedQrCode')}}】</p>
              <p>{{$t('produceAuthorizedQrCode')}}</p>
            </div>
          </div>
        </el-form-item>
      </el-form>


      <div class="step-wrap">
        <el-button type="primary" @click="handleQrClick" v-show="isMask">
          {{$t('createAuthorizedQrCode')}}
        </el-button>
      </div>
    </div>


  </div>

</template>

<script>

  // import AliApply from './apply'
  import {mapGetters} from 'vuex'
  import {payAliApply} from "@/api/delivery/pay/set";

  export default {
    name: 'wx-config',
    components: {
      // AliApply,
    },
    props: {
      name: {
        type: String,
        default: ''
      },
      uuid: {
        type: String,
        default: ''
      }
    },
    computed: {
      ...mapGetters(['employee'])
    },
    mounted: function () {
      if (this.uuid !== '') {
        this.info.name = this.name
        this.info.uuid = this.uuid
        payAliApply(this.info).then(res => {
          this.accessTokenUrl = res.data
          this.isMask = false
        })
      } else {
        this.accessTokenUrl = `二维码无效`
        this.isMask = true
      }
    },
    watch: {
      uuid: {
        immediate: true,    // 这句重要
        handler(val) {
          if (this.uuid !== '') {
            this.info.name = this.name
            this.info.uuid = this.uuid
            payAliApply(this.info).then(res => {
              this.accessTokenUrl = res.data
              this.isMask = false
            })
          } else {
            this.accessTokenUrl = `二维码无效`
            this.isMask = true
          }
        }
      }
    },
    data: function () {

      return {
        accessTokenUrl: ``,
        appId: `2021001173679595`,
        step: 0,
        type: 'individual',
        showAudit: false,
        isMask: true,
        info: {
          name: '',
          uuid: '',
        },
        uri: '',
        rules: {
          name: [
            {required: true, message: '请输入公司', trigger: 'blur'},
            {min: 3, message: '长度不少于3个字符', trigger: 'blur'}
          ],
        },
      }
    },
    methods: {
      handleCommit() {
        if (!this.info.name) {
          this.$message.warning('请输入支付名称')
        } else {
          // payAliApply(this.info).then(res => {
          //  this.accessTokenUrl = res.data
          // })
        }
      },
      handleQrClick() {
        if (!this.info.name) {
          this.$message.warning('请输入支付名称')
          return
        }
        payAliApply(this.info).then(res => {
          this.accessTokenUrl = res.data
          this.isMask = false
        })

      }
    }
  }
</script>

<style lang="scss">
  .pay-ali-config {
    padding: $padding;

    .alipay-info-title {
      color: $f_sec_color;
      padding: $padding;
    }

    &-container {
      padding: 5% 10%;
    }

    .el-form-item__label {
      color: #ffffff;
    }

    .qr-code {
      position: relative;

      .mark {
        width: 200px;
        height: 200px;
        background-color: #000000c7;
        padding-top: 60px;
        position: absolute;
        top: 0;
        left: 0;
        text-align: center;

        p {
          margin-top: 10px;
        }
      }
    }

    .step-wrap {
      margin-top: 40px;
      text-align: center;
    }

    .item-form {
      margin-top: $margin;
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }

    .padding240 {
      padding-right: 240px;
    }

  }
</style>
